import dayjs from 'dayjs';
import { GetValueParams } from '../types';

/**
 * Возвращает количество дней в месяце для заданного года и месяца.
 * @param year Год
 * @param month Месяц (0-11)
 * @returns Количество дней
 */
export const getDaysInMonth = (year: number, month: number): number => {
  return dayjs().year(year).month(month).daysInMonth();
};

/**
 * Генерирует массив чисел от start до end.
 * @param start Начало диапазона
 * @param end Конец диапазона
 * @returns Массив чисел
 */
export const generateRange = (start: number, end: number): number[] => {
  return Array.from({ length: end - start + 1 }, (_, index) => start + index);
};

export const getInputValue = ({
  selectedYear,
  selectedMonth,
  selectedDay,
  dateFormat
}: GetValueParams): string => {
  if (selectedYear !== undefined && selectedMonth !== undefined && selectedDay !== undefined) {
    return dayjs(`${selectedYear}-${selectedMonth + 1}-${selectedDay}`)
      .format(dateFormat)
      .toString();
  }
  return '';
};
